var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _vm.collapse
        ? _c("div", [
            _c(
              "p",
              {
                staticClass: "btn btn-fill btn-twitter",
                on: {
                  click: function($event) {
                    _vm.collapse = false
                  }
                }
              },
              [_vm._v("\n                Ekle\n            ")]
            )
          ])
        : _c("div", { ref: "panel", staticClass: "form-group card p-3" }, [
            _c(
              "div",
              [
                _vm._m(0),
                _vm._v(" "),
                _c("i18n-text", {
                  attrs: {
                    name: "visiting-point-title",
                    value: _vm.newVisitingPoint.title,
                    "create-hidden-input": false
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "py-2" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c(
                  "div",
                  {
                    staticClass: "d-flex",
                    staticStyle: { "align-items": "center", gap: "10px" }
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "btn btn-default",
                        attrs: { for: "files" }
                      },
                      [_vm._v("Resim ekle")]
                    ),
                    _vm._v(" "),
                    _vm.newVisitingPoint.image &&
                    _vm.newVisitingPoint.image.thumbnail
                      ? _c("img", {
                          staticStyle: { width: "100px" },
                          attrs: {
                            id: "upload-file-info",
                            readonly: "",
                            src:
                              "" +
                              _vm.image_service +
                              _vm.newVisitingPoint.image.thumbnail
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "btn btn-default",
                      staticStyle: { visibility: "hidden" },
                      attrs: {
                        id: "files",
                        type: "file",
                        accept: "image/png, image/jpeg, image/jpg"
                      },
                      on: {
                        change: function($event) {
                          return _vm.preview($event, "image")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.newVisitingPoint.image
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-danger btn-sm",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.deleteImage($event, "image")
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("close")
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "py-2" },
              [
                _c("label", { staticClass: "col-form-label" }, [
                  _vm._v("Görevler")
                ]),
                _vm._v(" "),
                _c("i18n-textarea", {
                  attrs: {
                    name: "visitin-point-missions",
                    value: _vm.newVisitingPoint.missions,
                    "create-hidden-input": false
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "py-2" },
              [
                _c("label", { staticClass: "col-form-label" }, [
                  _vm._v("Oyunlar")
                ]),
                _vm._v(" "),
                _c("building-visiting-point-game-select", {
                  attrs: {
                    games: _vm.newVisitingPoint.games,
                    name: "visitingPointGames[]"
                  },
                  on: { "update-games": _vm.updateGames }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "py-2" }, [
              _c(
                "p",
                {
                  staticClass: "btn btn-fill btn-twitter",
                  on: { click: _vm.add }
                },
                [_vm._v("\n                    Ekle\n                ")]
              )
            ])
          ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { "padding-top": "20px" } },
      [
        _c(
          "draggable",
          {
            on: {
              start: function($event) {
                _vm.drag = true
              },
              end: function($event) {
                _vm.drag = false
              }
            },
            model: {
              value: _vm.visitingPoints,
              callback: function($$v) {
                _vm.visitingPoints = $$v
              },
              expression: "visitingPoints"
            }
          },
          [
            _c(
              "transition-group",
              _vm._l(_vm.visitingPoints, function(visitingPoint, vKey) {
                return _c(
                  "div",
                  { key: vKey },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex",
                        staticStyle: { "align-items": "center", gap: "10px" }
                      },
                      [
                        _c(
                          "i",
                          {
                            staticClass: "material-icons",
                            staticStyle: { cursor: "move" }
                          },
                          [_vm._v("drag_indicator")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "d-flex",
                            staticStyle: {
                              "align-items": "center",
                              gap: "10px"
                            }
                          },
                          [
                            visitingPoint.image && visitingPoint.image.thumbnail
                              ? _c("img", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    src:
                                      "" +
                                      _vm.image_service +
                                      visitingPoint.image.thumbnail
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  "font-weight": "800",
                                  "justify-content": "end",
                                  "align-items": "end",
                                  width: "200px"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(visitingPoint.title["tr_TR"]) +
                                    "\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex",
                                staticStyle: {
                                  "flex-wrap": "wrap",
                                  gap: "5px",
                                  "justify-content": "end",
                                  "align-items": "end",
                                  width: "100px"
                                }
                              },
                              _vm._l(visitingPoint.games, function(
                                game,
                                gmKey
                              ) {
                                return _c(
                                  "span",
                                  {
                                    key: game.id,
                                    staticClass: "label-success"
                                  },
                                  [_vm._v(_vm._s(game.value))]
                                )
                              }),
                              0
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "d-flex",
                            staticStyle: {
                              "align-items": "center",
                              gap: "10px"
                            }
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "btn btn-fill btn-twitter",
                                on: {
                                  click: function($event) {
                                    return _vm.edit(vKey)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Düzenle\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "btn btn-fill btn-twitter",
                                on: {
                                  click: function($event) {
                                    return _vm.remove(vKey)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Sil\n                            "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "vue-final-modal",
                      {
                        key: visitingPoint.id,
                        attrs: {
                          classes: "modal-container",
                          "content-class": "modal-content",
                          "click-to-close": false,
                          "esc-to-close": false
                        },
                        model: {
                          value: visitingPoint.showEditing,
                          callback: function($$v) {
                            _vm.$set(visitingPoint, "showEditing", $$v)
                          },
                          expression: "visitingPoint.showEditing"
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "modal__title" },
                          [
                            _vm._t("title", function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex",
                                    staticStyle: {
                                      "justify-content": "space-between",
                                      "align-items": "center"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    Güncelle\n\n                                    "
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary btn-md",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeEditingModal(
                                              visitingPoint
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Kaydet"
                                        ),
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("update")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "modal__content" },
                          [
                            _c("building-visiting-point-editor", {
                              key: _vm.visitingPoints[vKey].id,
                              attrs: {
                                "editing-visiting-points":
                                  _vm.visitingPoints[vKey]
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              }),
              0
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", [
      _c("input", {
        attrs: { type: "hidden", name: "visitingPoints" },
        domProps: { value: JSON.stringify(_vm.visitingPoints) }
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-form-label" }, [
      _vm._v("Baslik\n                    "),
      _c("span", { staticStyle: { color: "gainsboro" } }, [_vm._v("(*)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-form-label" }, [
      _vm._v("Resim "),
      _c("span", { staticStyle: { color: "gainsboro" } }, [_vm._v("(*)")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fad40bfe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fad40bfe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/vue/building-visiting-point-creator.vue
// module id = 123
// module chunks = 0